import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';

import { InputQuantityComponent } from './inputquantity/inputquantity.component';
import { InputQuantityContractComponent } from './inputquantitycontract/inputquantitycontract.component';
import { InputQuantityCostComponent } from './inputquantitycost/inputquantitycost.component';
import { InputQuantityOrderComponent } from './inputquantityorder/inputquantityorder.component';
import { InputValueContractComponent } from './inputvaluecontract/inputvaluecontract.component';
import { InputValueComponent } from './inputvalue/inputvalue.component';
import { InputValueCostComponent } from './inputvaluecost/inputvaluecost.component';
import { InputValueOrderComponent } from './inputvalueorder/inputvalueorder.component';
import { DonutChartModule } from 'src/app/cp-donutchart/cp-donutchart.module';
import { GaugeChartModule } from 'src/app/cp-gauge/cp-gauge.module';
import { TwoBarschartModule } from 'src/app/cp-twobarschart/cp-twobarschart.module';
import { CpWidgetModule } from 'src/app/cp-widget/cp-widget.module';
import { LoadingButtonModule } from 'src/app/cp-loadingbutton/cp-loadingbutton.module';
import { InputDisclaimerGroupModule } from 'src/app/cp-inputdisclaimergroup/cp-inputdisclaimergroup.module';
import { InputChartsComponent } from './inputcharts.component';

@NgModule({
  declarations: [
    InputQuantityComponent,
    InputQuantityContractComponent,
    InputQuantityCostComponent,
    InputQuantityOrderComponent,
    InputValueComponent,
    InputValueContractComponent,
    InputValueCostComponent,
    InputValueOrderComponent,
    InputChartsComponent
  ],
  imports: [
    CommonModule,
    PoModule,
    DonutChartModule,
    GaugeChartModule,
    TwoBarschartModule,
    CpWidgetModule,
    LoadingButtonModule,
    InputDisclaimerGroupModule
  ],
  exports: [
    InputQuantityComponent,
    InputQuantityContractComponent,
    InputQuantityCostComponent,
    InputQuantityOrderComponent,
    InputValueComponent,
    InputValueContractComponent,
    InputValueCostComponent,
    InputValueOrderComponent,
    InputChartsComponent
  ]
})

export class InputChartsModule{}
